import { requestTool } from '@mx/pay-common';
import { sharkFetch } from '@mx/neo';
import { toast } from '@mx/vix';
import { sc } from '@/analytic/lx-constants';

requestTool.installSharkApi(sharkFetch);
/**
 * 设置通用请求参数
 * @param data {Record<string, any>} 通用请求参数
 */
export function setCommonData(data: Record<string, any>): void {
  requestTool.setCommonData(data);
}
const statOptions = {
  start: {
    bid: sc.ajaxRequestStart,
  },
  success: {
    bid: sc.ajaxRequestSuccess,
  },
};
// options 参考文档：https://km.sankuai.com/page/922070148
export function ajax(url: string, options?: AjaxOptionsType, showToast?: boolean): Promise<any> {
  if (showToast) {
    toast.show('loading', '', {
      delay: 0,
    });
  }
  // 开发环境统一 proxy 到 /mock/*
  let urlPath = url;
  if (process.env.NODE_ENV === 'development') {
    urlPath = `/mock${url}`;
  }
  // const urlPath = url;
  return requestTool
    .request({
      url: urlPath,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      encodeData: true,
      validateResponse: true,
      checkBizCommonError: true,
      ...options,
      statOptions,
    })
    .then((res) => {
      const data = res.data as BaseType;
      return new Promise((resolve, reject) => {
        if (data.status === 'success') {
          resolve(data.data);
        }
        reject(data.error);
      });
    })
    .finally(() => {
      if (showToast) {
        toast.hide();
      }
    });
}
